module.exports = __webpack_public_path__ + "static/3i-f20b178ca2024a5eac8e42e6649db86c.woff2";